/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ObjectResponseDto } from '../models/ObjectResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AnalyticsService {
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static analyticsControllerTeamTestMatrix({
        id,
        tid,
        testId,
    }: {
        id: string,
        tid: string,
        testId: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/companies/{id}/teams/{tid}/test',
            path: {
                'id': id,
                'tid': tid,
            },
            query: {
                'testId': testId,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static analyticsControllerTeamBundle({
        id,
        tid,
    }: {
        id: string,
        tid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/companies/{id}/teams/{tid}/bundle',
            path: {
                'id': id,
                'tid': tid,
            },
        });
    }
    public static analyticsControllerTeamCard({
        id,
        tid,
    }: {
        id: string,
        tid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/companies/{id}/teams/{tid}/card',
            path: {
                'id': id,
                'tid': tid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static analyticsControllerTeamInsights({
        id,
        tid,
    }: {
        id: string,
        tid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/companies/{id}/teams/{tid}/insights',
            path: {
                'id': id,
                'tid': tid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static analyticsControllerMemberProfile({
        id,
        tid,
        userId,
    }: {
        id: string,
        tid: string,
        userId: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/companies/{id}/teams/{tid}/members/{userId}/profile',
            path: {
                'id': id,
                'tid': tid,
                'userId': userId,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static analyticsControllerCompanyTestMatrix({
        id,
        testId,
    }: {
        id: string,
        testId: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/companies/{id}/test',
            path: {
                'id': id,
            },
            query: {
                'testId': testId,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static analyticsControllerCompanyInsights({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/companies/{id}/company-insights',
            path: {
                'id': id,
            },
        });
    }
}
